import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getBlogCategories, getBlogPosts, getBlogPostBySlug } from '../actions';

export const useBlogCategories = () => {
  const dispatch = useDispatch();
  const { categories, isLoading, error } = useSelector((state) => state.blogCategory);

  const refetch = () => {
    dispatch(getBlogCategories());
  };

  useEffect(() => {
    if (!categories || (Array.isArray(categories) && categories.length === 0)) {
      dispatch(getBlogCategories());
    }
  }, [dispatch]);

  return {
    categories,
    isLoading,
    error,
    refetch,
  };
};

export const useBlogPosts = (filters = {}) => {
  const dispatch = useDispatch();
  const { posts, isLoading, error } = useSelector((state) => state.blogPost);

  useEffect(() => {
    dispatch(getBlogPosts(filters));
  }, [dispatch, JSON.stringify(filters)]);

  return {
    posts,
    isLoading,
    error,
  };
};

export const useBlogPostDetail = (slug) => {
  const dispatch = useDispatch();
  const { currentPost, isLoading, error } = useSelector((state) => state.blogPostDetail);

  useEffect(() => {
    if (slug) {
      dispatch(getBlogPostBySlug(slug));
    }
  }, [dispatch, slug]);

  return {
    post: currentPost,
    isLoading,
    error,
  };
};

export const useBlogComments = (postId) => {
  const dispatch = useDispatch();
  const { comments, isLoading, error } = useSelector((state) => state.blogComment);

  return {
    comments,
    isLoading,
    error,
  };
};

export const useBlogFeaturedPosts = () => {
  const { featuredPosts, isLoading, error } = useSelector((state) => state.blogFeaturedPosts);

  return {
    featuredPosts,
    isLoading,
    error,
  };
};